import React from 'react';

export const EmptyState = () => {
  return <div className="b--alto bg-wild-sand br3 b--dashed h-100 bw1" />;
};
